/**
 * Client call slot state.
 *
 * This is a client-side wrapper vocabulary describing whether the client
 * currently has an active call context at all.
 *
 * Rules:
 * - IDLE means no active call context is present.
 * - ACTIVE means an active call context exists and its lifecycle is governed
 *   by `serverCallState`.
 * - ERROR means the client is in a local error state relevant to call handling.
 *
 * This type is intentionally separate from the server lifecycle.
 */
export const CALL_SLOT_STATE = {
    IDLE: "IDLE",
    ACTIVE: "ACTIVE",
    ERROR: "ERROR",
};
